import styled, { withTheme } from 'styled-components';
import React, { PureComponent, ReactNode } from 'react';
import SectionTitle from '@flow/scenes/home/components/section-title/SectionTitle';
import { Link, withRouteData } from 'react-static';
import Ticker from '@flow/components/ticker/Ticker';
import BasicButton from '@flow/components/ui/button/BasicButton';
import FlowStripe from '@flow/components/ticker/FlowStripe';
import { getRandomInt } from '@flow/utils/numberUtils';
import { isNew } from '@flow/utils/helperUtils';
import Moment from 'react-moment';
import em from 'polished/lib/helpers/em';
import { getRelativeUrl } from '@flow/utils/cleaners';
import { IArtist } from 'types/IArtist';
import { shuffleArray } from '@flow/utils/arrayUtils';
import { NewBadge } from '@flow/components/ui';
import { Waypoint } from 'react-waypoint';
import { TextAnimation } from '@flow/components/animation/TextAnimation';

const Block = styled.div`
  //padding-top: 59.13%;
  //width: 100%;
`;

const Artist = styled.div`
  width: 50%;
  box-sizing: border-box;
  position: relative;
 
  &:nth-child(even) {
    margin-right: 3.3em;
  }
  
  &:nth-child(odd) {
    margin-left: 3.3em;
    a {
      flex-direction: column-reverse;
    }
  }
  
  time {
    position: absolute;
    font-family: Flow-Poster-Bold;
    font-size: 2.8em;
    white-space: nowrap;
    width: 100%;
    box-sizing: border-box;
    padding: ${em(3, 2.8)};
    text-align: left;
    text-transform: uppercase;
    
    @media (max-width: 1400px) {
      font-size: ${34 / (1920 * 0.01)}vw;
    }
    
    @media (max-width: 970px) {
      font-size: ${40 / (1920 * 0.01)}vw;
    }
  }
  
  a {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    justify-content: space-between;
    height: 100%;
  }
  
  &:${props => props.theme.hoverProperty} {
   a {
    background-color: ${props => props.theme.highlightColor};
   }
  }
`;

const Content = styled.div`
  position: relative;
  width: 100%;
  flex: 1 0 0;
`;

const ContentContainer = styled.div`
  position: relative;
  padding-top: 59.13%;
  box-sizing: border-box;
  
  ${Artist}.no-image & {
    padding-top: 118.26%;
  }
`;

const ContentWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

const ArtistName = styled.h2`
  font-size: 13.3em;
  text-transform: uppercase;
  white-space: pre-line;
  padding: 0 ${em(1, 13.3)};
  
  ${Artist}.no-image & {
    //font-size: 23.2em;  
  }
  
  &.font-family-index-0 {
    font-family: Flow-Inverted;
  }
  
  &.font-family-index-1 {
    font-family: Flow-Poster-Bold;
  }
  
  &.font-family-index-2 {
    font-family: Flow-LightDisplay;
  }
  
  @media (max-width: 1920px) {
    font-size: ${133 / (1920 * 0.01)}vw;
  }
`;


const ImageWrapper = Block.extend`
  position: relative;
  width: 100%;
`;

const Figure = styled.figure`
  padding-top: 59.13%; 
  background-image: url(${props => props.isRetina ? props.image['large'] : props.image['medium']});
  background-size: cover;
`;

const FullLineupLinkWrapper = styled.div`
  margin-top: 3em;
  padding: 0 3em;
  text-align: right;
`;

const ArtistCollectionWrapper = styled.div`
  border-top: 0.2em solid ${props => props.theme.highlightColor};
  
  @media only screen and (max-width: 374px) {
    display: none;
  }
`;

const ArtistRow = styled.div`
  /*@media only screen and (max-width: 760px) {
    &:not(:last-child) {
      display: none;
    }
  }*/
`;

const StripeWrapper = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 100%;
  width: 6.6em;
  box-sizing: border-box;
  border-right: 0.2em solid ${props => props.theme.highlightColor};
  border-left: 0.2em solid ${props => props.theme.highlightColor};
  overflow: hidden;
`;

const ArtistColumns = styled.div`
  position: relative;
  display: flex;
  
  @media only screen and (max-width: 760px) {
    flex-wrap: wrap;
    
    ${ArtistName} {
      font-size: ${200 / (1920 * 0.01)}vw;
    }
    
    ${ContentContainer} {
      padding: ${300 / (1920 * 0.01)}vw 3em !important; 
    }
    
    ${ContentWrapper} {
      position: relative;
    }
    
    ${ArtistRow} {
      &:first-child {
        display: none;
      }
    }
    
    ${Artist} {
      width: 100%;
      margin-right: 0;
      margin-left: 0;
      
      a {
        flex-direction: column-reverse;
      }
      
      time {
        font-size: ${75 / (1920 * 0.01)}vw;
      }
    }
    
    ${StripeWrapper} {
      display: none;
    }
  }
`;


const NarrowArtistLiftWrapper = styled.div`
  a {
    display: block;
  }
  
  @media only screen and (min-width: 374px) {
    display: none;
  }
`;

const NarrowArtistLiftText = styled.div`
  font-size: 2.1em;
  text-align: center;
  padding-left: ${em(3, 2.1)};
  padding-right: ${em(3, 2.1)};
  line-height: ${em(4.8, 2.1)};
  
  span {
    text-transform: uppercase;
    &:not(:last-child) {
      &:after {
        content: '/';
        font-family: Flow-Poster-Bold;
        display: inline-block;
        padding-right: ${em(1, 2.1)};
        padding-left: ${em(1, 2.1)};
      }    
    }
  }
`;

const NewBadgeWrapper = styled.div`
  position: absolute;
  top: 2em; 
  left: 2em;
`;

interface ArtistItemProps {
  artist: IArtist;
  appLanguage: IAppLanguage;
  isMobile?: boolean;
}

interface ArtistItemState {
  renderArtistContent: boolean;
  animateContentIn: boolean;
}


class ArtistItem extends PureComponent<ArtistItemProps, ArtistItemState> {
  constructor(props: ArtistItemProps) {
    super(props);

    this.state = {
      renderArtistContent: false,
      animateContentIn: false
    }
  }

  componentDidMount() {
    this.setState({renderArtistContent: true});
  }

  private _handleWaypointEnter = (): void => {
    this.setState({animateContentIn: true});
  };

  render() {
    const { artist, appLanguage } = this.props;
    const { renderArtistContent } = this.state;

    return (
      <Artist className={artist.images && artist.images.landscape.length > 0 ? '' : 'no-image'}>
        <Link to={getRelativeUrl(artist.url)}>
          {Boolean(artist.date) &&
          <Moment locale={appLanguage.code} format={'dddd Do YYYY'} date={artist.date}/>
          }
          <Content>
            { renderArtistContent &&
              this._renderContent(artist)
            }
          </Content>
          {Boolean(artist.images) && Boolean(artist.images.landscape) && Boolean(artist.images.landscape.length > 0) &&
          <ImageWrapper>
            {isNew(artist.date) &&
            <NewBadgeWrapper>
              <NewBadge/>
            </NewBadgeWrapper>
            }
            <Figure image={artist.images.landscape[0]}/>
          </ImageWrapper>
          }
        </Link>
      </Artist>
    )
  }

  private _renderContent = (artist: IArtist): ReactNode => {
    const {
      isMobile
    } = this.props;
    if (!isMobile) {
      return (
        <Waypoint
          onEnter={this._handleWaypointEnter}>
          <ContentContainer>
            <ContentWrapper>
              <ArtistName className={'font-family-index-' + getRandomInt(0, 2)}>
                <TextAnimation text={artist.title} animateIn={this.state.animateContentIn}/>
              </ArtistName>
            </ContentWrapper>
          </ContentContainer>
        </Waypoint>
      );
    } else {
      return (
        <ContentContainer>
          <ContentWrapper>
            <ArtistName className={'font-family-index-' + getRandomInt(0, 2)}>
              {artist.title}
            </ArtistName>
          </ContentWrapper>
        </ContentContainer>
      );
    }
  }
}

interface Props {
  program: any;
  appLanguage: IAppLanguage;
  theme?: any;
}

const ArtistLift = ({
  program,
  appLanguage,
  theme: {
    isMobile
  }
}: Props) => {
  const {
    title,
    artists_lift = [],
    artists_ticker = [],
    lift_cta_group: {
      label,
      link
    }
  } = program;

  let narrowArtistLiftItems = [];
  if (artists_ticker) {
    if (artists_ticker.length < 10) {
      narrowArtistLiftItems = artists_ticker;
    } else {
      let shuffledTickerList = shuffleArray(artists_ticker);
      for(let i: number = 0; i < 10; i++) {
        narrowArtistLiftItems.push(shuffledTickerList[i]);
      }
    }
  }

  return (
    <div>
      {Boolean(title) && <SectionTitle title={title}/>}
      {artists_lift && artists_lift.length > 0 &&
      <div>
        <ArtistCollectionWrapper>
          {artists_lift && artists_lift.length > 0 && artists_lift.map((row: IArtist[], index: number) =>
            <ArtistRow key={index}>
              <ArtistColumns>
                <StripeWrapper>
                  <FlowStripe animate={true} rotation={90} color={'#000000'} />
                </StripeWrapper>
                {row && row.length > 0 && row.map((artist: IArtist, index: number) =>
                  <ArtistItem key={index} artist={artist} appLanguage={appLanguage} isMobile={isMobile} />
                )}
              </ArtistColumns>
              {(Boolean(artists_ticker) && Boolean(artists_ticker.length)) && <div className="ticker-wrapper">
                <Ticker appLanguage={appLanguage} items={artists_ticker}/>
              </div>}
            </ArtistRow>
          )}
        </ArtistCollectionWrapper>
        <NarrowArtistLiftWrapper>
          <Link to={link.url}>
            <NarrowArtistLiftText>
              {(Boolean(narrowArtistLiftItems) && Boolean(narrowArtistLiftItems.length)) && narrowArtistLiftItems.map((artist, index: number) =>
                <span key={index}>{artist.title}</span>
              )}
            </NarrowArtistLiftText>
          </Link>
        </NarrowArtistLiftWrapper>
        <FullLineupLinkWrapper>
          <BasicButton label={label} href={link.url}/>
        </FullLineupLinkWrapper>
      </div>
      }
    </div>
  )
};

export default withRouteData(withTheme(ArtistLift));



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/home/components/artist-lift/ArtistLift.tsx